export default __webpack_public_path__ + "static/media/TC02.9205f777.svg";